import firebase from "firebase";

var config = {
  apiKey: "AIzaSyByyhlriK2-7mtXbEqg-x97c42zWVfJMiE",
  authDomain: "tourbrazil-41fbe.firebaseapp.com",
  databaseURL: "https://tourbrazil-41fbe.firebaseio.com",
  projectId: "tourbrazil-41fbe",
  storageBucket: "tourbrazil-41fbe.appspot.com",
  messagingSenderId: "927605208400"
};

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

export const GetPromo = email => {
  return dispatch => {
    firebase.auth().onAuthStateChanged(user => {
      var id = user.uid;
      var markers = firebase
        .database()
        .ref("promocoes/" + id)
        .orderByKey();
      markers.on("value", snapshot => {
        var emp = [];
        snapshot.forEach(e => {
          var img = e.child("img").val();
          var conteudo = e.child("conteudo").val();
          var nome = e.child("nome").val();
          var promocao = e.child("promocao").val();
          var valor = e.child("valor").val();
          var dataPost = e.child("dataPost").val();
          var vencimento = e.child("vencimento").val();
          var link = e.child("link").val();
          var valido = null;
          if (dataPost <= vencimento) {
            valido = "Ativa";
            console.log(dataPost);
            console.log(vencimento);
          } else {
            valido = "Vencida";
            console.log(dataPost);
            console.log(vencimento);
          }
          if (e.child("promocao").val() == "00.00") {
            promocao = "";
          } else {
            promocao = "R$ " + e.child("promocao").val();
          }
          if (e.child("valor").val() == "00.00") {
            valor = "";
          } else {
            promocao = "R$ " + e.child("valor").val();
          }
          var all = {
            id: e.key,
            img: img,
            conteudo: conteudo,
            nome: nome,
            promocao: promocao,
            valor: valor,
            valido: valido,
            link: link,
            dataPost: dataPost
          };
          emp.push(all);
        });
        return dispatch({ type: "PROMOS", payload: emp });
      });
    });
  };
};



// WEBPACK FOOTER //
// ./src/redux/actions/getPromo.js